import TargetGroup from '../entities/TargetGroup'

const terms = {
  TARGET_GROUP_ID: '_id',
  TARGET_GROUP_CONDITION: 'condition',
}

export default class TargetGroupsParser {
  _json
  constructor(json) {
    this._json = json
  }

  parse() {
    if (!this._json || !this._json.length) {
      return []
    }

    const targetGroups = []

    this._json.forEach((json) => {
      if (!json || !json[terms.TARGET_GROUP_ID] || !json[terms.TARGET_GROUP_CONDITION]) {
        return
      }
      targetGroups.push(
        new TargetGroup(json[terms.TARGET_GROUP_ID], json[terms.TARGET_GROUP_CONDITION])
      )
    })

    return targetGroups
  }
}
